// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimePicker_wrap__wz73i {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  box-sizing: border-box;
  background: var(--dylo-field-bg);
  border: 1px solid var(--dylo-field-border);
  border-radius: 10px;
  padding: 0 8px 0 0;
  height: 40px;
}
.TimePicker_wrap__wz73i.TimePicker_open__5aiB6,
.TimePicker_wrap__wz73i:focus-within {
  border-color: var(--dylo-teal-500);
}
.TimePicker_wrap__wz73i.TimePicker_disabled__Z5pAY {
  opacity: 0.6;
}

.TimePicker_trigger__3kRUU {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  height: 100%;
  padding: 0 4px 0 12px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: var(--font-sans);
  font-size: 13.5px;
  color: var(--dylo-ink);
}
.TimePicker_trigger__3kRUU:disabled {
  cursor: not-allowed;
}
.TimePicker_value__zEcV9 {
  font-variant-numeric: tabular-nums;
}
.TimePicker_placeholder__XI76M {
  color: var(--dylo-muted);
}
.TimePicker_icon__GWB1q {
  display: inline-flex;
  color: var(--dylo-field-icon);
  flex-shrink: 0;
  transition: color 0.15s ease;
}
.TimePicker_trigger__3kRUU:hover .TimePicker_icon__GWB1q {
  color: var(--dylo-teal-700);
}
.TimePicker_clear__acgHc {
  border: none;
  background: none;
  color: var(--dylo-field-icon);
  cursor: pointer;
  display: inline-flex;
  padding: 2px;
  border-radius: 4px;
  flex-shrink: 0;
}
.TimePicker_clear__acgHc:hover {
  color: var(--dylo-ink);
}

/* Panel */
.TimePicker_panel__JsDlJ {
  position: absolute;
  left: 0;
  top: calc(100% + 6px);
  z-index: 60;
  display: flex;
  background: var(--dylo-surface);
  border: 1px solid var(--dylo-surface-border);
  border-radius: 12px;
  box-shadow: var(--shadow-card);
  overflow: hidden;
  transform-origin: top left;
  animation: TimePicker_dylo-dropdown__JyY7G 0.18s cubic-bezier(0.16, 1, 0.3, 1) both;
}
.TimePicker_col__Iixpp {
  width: 60px;
  max-height: 220px;
  overflow-y: auto;
  padding: 8px 6px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  scrollbar-width: thin;
  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;
}
.TimePicker_col__Iixpp + .TimePicker_col__Iixpp {
  border-left: 1px solid var(--dylo-line);
}
.TimePicker_col__Iixpp::-webkit-scrollbar {
  width: 6px;
}
.TimePicker_col__Iixpp::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);
  border-radius: 3px;
}
.TimePicker_item__NggrP {
  border: none;
  background: transparent;
  color: var(--dylo-ink);
  font-family: var(--font-sans);
  font-size: 12.5px;
  font-variant-numeric: tabular-nums;
  padding: 7px 0;
  border-radius: 7px;
  cursor: pointer;
  text-align: center;
  transition: background 0.12s ease, color 0.12s ease;
}
.TimePicker_item__NggrP:hover {
  background: color-mix(in srgb, var(--dylo-teal-700) 12%, transparent);
}
.TimePicker_itemActive__U9RO7 {
  background: var(--dylo-teal-700);
  color: #fff;
  font-weight: 600;
}
.TimePicker_itemActive__U9RO7:hover {
  background: var(--dylo-teal-700);
}

@media (prefers-reduced-motion: reduce) {
  .TimePicker_panel__JsDlJ { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/v2/components/ui/TimePicker/TimePicker.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,gCAAgC;EAChC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;AACA;;EAEE,kCAAkC;AACpC;AACA;EACE,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,OAAO;EACP,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,4CAA4C;EAC5C,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,mFAAiE;AACnE;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;EACrB,mFAAmF;AACrF;AACA;EACE,uCAAuC;AACzC;AACA;EACE,UAAU;AACZ;AACA;EACE,kEAAkE;EAClE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mDAAmD;AACrD;AACA;EACE,qEAAqE;AACvE;AACA;EACE,gCAAgC;EAChC,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAAS,eAAe,EAAE;AAC5B","sourcesContent":[".wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  box-sizing: border-box;\n  background: var(--dylo-field-bg);\n  border: 1px solid var(--dylo-field-border);\n  border-radius: 10px;\n  padding: 0 8px 0 0;\n  height: 40px;\n}\n.wrap.open,\n.wrap:focus-within {\n  border-color: var(--dylo-teal-500);\n}\n.wrap.disabled {\n  opacity: 0.6;\n}\n\n.trigger {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  height: 100%;\n  padding: 0 4px 0 12px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-family: var(--font-sans);\n  font-size: 13.5px;\n  color: var(--dylo-ink);\n}\n.trigger:disabled {\n  cursor: not-allowed;\n}\n.value {\n  font-variant-numeric: tabular-nums;\n}\n.placeholder {\n  color: var(--dylo-muted);\n}\n.icon {\n  display: inline-flex;\n  color: var(--dylo-field-icon);\n  flex-shrink: 0;\n  transition: color 0.15s ease;\n}\n.trigger:hover .icon {\n  color: var(--dylo-teal-700);\n}\n.clear {\n  border: none;\n  background: none;\n  color: var(--dylo-field-icon);\n  cursor: pointer;\n  display: inline-flex;\n  padding: 2px;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n.clear:hover {\n  color: var(--dylo-ink);\n}\n\n/* Panel */\n.panel {\n  position: absolute;\n  left: 0;\n  top: calc(100% + 6px);\n  z-index: 60;\n  display: flex;\n  background: var(--dylo-surface);\n  border: 1px solid var(--dylo-surface-border);\n  border-radius: 12px;\n  box-shadow: var(--shadow-card);\n  overflow: hidden;\n  transform-origin: top left;\n  animation: dylo-dropdown 0.18s cubic-bezier(0.16, 1, 0.3, 1) both;\n}\n.col {\n  width: 60px;\n  max-height: 220px;\n  overflow-y: auto;\n  padding: 8px 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  scrollbar-width: thin;\n  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;\n}\n.col + .col {\n  border-left: 1px solid var(--dylo-line);\n}\n.col::-webkit-scrollbar {\n  width: 6px;\n}\n.col::-webkit-scrollbar-thumb {\n  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);\n  border-radius: 3px;\n}\n.item {\n  border: none;\n  background: transparent;\n  color: var(--dylo-ink);\n  font-family: var(--font-sans);\n  font-size: 12.5px;\n  font-variant-numeric: tabular-nums;\n  padding: 7px 0;\n  border-radius: 7px;\n  cursor: pointer;\n  text-align: center;\n  transition: background 0.12s ease, color 0.12s ease;\n}\n.item:hover {\n  background: color-mix(in srgb, var(--dylo-teal-700) 12%, transparent);\n}\n.itemActive {\n  background: var(--dylo-teal-700);\n  color: #fff;\n  font-weight: 600;\n}\n.itemActive:hover {\n  background: var(--dylo-teal-700);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .panel { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `TimePicker_wrap__wz73i`,
	"open": `TimePicker_open__5aiB6`,
	"disabled": `TimePicker_disabled__Z5pAY`,
	"trigger": `TimePicker_trigger__3kRUU`,
	"value": `TimePicker_value__zEcV9`,
	"placeholder": `TimePicker_placeholder__XI76M`,
	"icon": `TimePicker_icon__GWB1q`,
	"clear": `TimePicker_clear__acgHc`,
	"panel": `TimePicker_panel__JsDlJ`,
	"dylo-dropdown": `TimePicker_dylo-dropdown__JyY7G`,
	"col": `TimePicker_col__Iixpp`,
	"item": `TimePicker_item__NggrP`,
	"itemActive": `TimePicker_itemActive__U9RO7`
};
export default ___CSS_LOADER_EXPORT___;
